<template>
  <div class="badge">
    <slot></slot>
    <div v-if="active" class="red-dot">
      {{ count }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: [Boolean, Number],
      default: false,
    },
  },
  computed: {
    count() {
      if (typeof this.active === 'boolean') {
        return '';
      }
      return this.active;
    },
  },
};
</script>

<style lang="scss" scoped>
.badge {
  position: relative;
  padding: 0;
  .red-dot {
    position: absolute;
    width: 14px;
    height: 14px;
    top: 8px;
    right: 8px;
    border-radius: 50%;
    z-index: 5;
    background-color: $accent;
  }
}
</style>
